import { createContext, useCallback, useContext, useState } from "react";

const IndustryModalContext = createContext({ active: null, open: () => {}, close: () => {} });

export function IndustryModalProvider({ children }) {
    const [active, setActive] = useState(null);
    const open = useCallback((key) => setActive(key), []);
    const close = useCallback(() => setActive(null), []);
    return (
        <IndustryModalContext.Provider value={{ active, open, close }}>
            {children}
        </IndustryModalContext.Provider>
    );
}

export function useIndustryModal() { return useContext(IndustryModalContext); }
